angular.module('app').config(discountCouponsRouting);

function discountCouponsRouting($routeProvider) {
  $routeProvider
    .when('/discount_coupons', {
      pageTitle: 'DISCOUNT_COUPONS',
      template: '<discount-coupon-list></discount-coupon-list>',
      breadcrumb: {
        label: 'COMPANY_SETTINGS',
        parent: 'ng/company_settings',
      },
      menu: 'settings',
      accessPermission: 'index_discountcoupon_accountadmin',
      authReq: true,
    })
    .when('/discount_coupons/new', {
      pageTitle: 'ADD_DISCOUNT_COUPON',
      template: '<discount-coupon-detail></discount-coupon-detail>',
      breadcrumb: {
        label: 'DISCOUNT_COUPONS',
        parent: 'discount_coupons',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'create_discountcoupon_accountadmin',
      authReq: true,
    })
    .when('/discount_coupons/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'DISCOUNT_COUPON',
      template: '<discount-coupon-detail></discount-coupon-detail>',
      breadcrumb: {
        label: 'DISCOUNT_COUPONS',
        parent: 'discount_coupons',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'show_discountcoupon_accountadmin',
      authReq: true,
    });
}

discountCouponsRouting.$inject = ['$routeProvider'];
